import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ConfirmActionDialog from "../../../components/ConfirmActionDialog";
import { deleteEventsLogVisitor } from "../../../axios/Visitor/VisitorApi";

const RemoveEventLogDialog = ({ dataInfo, id, onClose, onRefresh }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleCloseDialog = () => {
    if (loading) return;
    onClose?.();
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      const payload = {
        langId: localStorage.getItem("i18nextLngId"),
        eventId: dataInfo?.id,
        visitorEventLogId: id,
      };
      const response = await deleteEventsLogVisitor(payload);

      if (response?.status === 200) {
        toast.success(t("common.delete-participants-successfully"));
        onRefresh?.();
        onClose?.();
      } else {
        toast.error(response?.data?.message || t("common.error"));
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message || t("common.network-or-server-error")
      );
      console.error("Delete visitor event error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmActionDialog
      open
      variant="delete"
      title={t("common.delete-visitor-user")}
      subtitle={t("common.are-you-sure-delete-this-visitor-user")}
      confirmText={t("button.delete")}
      loading={loading}
      onClose={handleCloseDialog}
      onConfirm={handleDelete}
    />
  );
};

export default RemoveEventLogDialog;
